export default (str = "") => (str && str.replace(/GA[0-9]\.[0-9]\./, "")) || "";
